import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import analytics from '../../../lib/analytics';
import ConnectorView from '../../../components/shared/connectors/connector-view';
import { getConnectors } from '../../../lib/side-effects';
const SelectConnector = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getConnectors());
        analytics.page('SELECT_CONNECTOR_INFO');
    }, []);
    return React.createElement(ConnectorView, Object.assign({}, props));
};
export default SelectConnector;
